(function () {
  const MEDIA_ELEMENTS = 'img, picture, video, model-viewer';
  const MEDIA_CONTAINERS = 'media-gallery, .product-media-modal';
  const MEDIA_SELECTOR = MEDIA_ELEMENTS + ', ' + MEDIA_CONTAINERS;

  function targetIsMedia(target) {
    return target instanceof Element && Boolean(target.closest(MEDIA_SELECTOR));
  }

  function blockOnMedia(event) {
    if (event.clientX <= 0 && event.clientY <= 0) {
      if (targetIsMedia(event.target)) event.preventDefault();
      return;
    }

    const stack = document.elementsFromPoint(event.clientX, event.clientY);
    if (stack.some((el) => el.matches(MEDIA_SELECTOR))) event.preventDefault();
  }

  document.addEventListener('contextmenu', blockOnMedia);
  document.addEventListener('dragstart', blockOnMedia);
})();
